import ApiService from '@/services/ApiService';

const apiService = new ApiService();

const create = async function(data) {
    const invite = {
        displayName: data.name,
        sessionId: data.sessionId,
        sessionName: data.sessionName
    };

    return apiService.post('invite', invite);
}

const getBySessionId = async function(sessionId) {
    return apiService.get('invite', `session/${sessionId}`);
}

export default {
    create,
    getBySessionId
}